"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStockLocationSchema = exports.createStockLocationSchema = exports.stockLocationShape = void 0;
const zod_1 = require("zod");
exports.stockLocationShape = {
    locationCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    locationTypeId: zod_1.z.string().uuid().optional(),
    branchId: zod_1.z.string().uuid(),
    isActive: zod_1.z.boolean().default(true),
};
exports.createStockLocationSchema = zod_1.z.object(exports.stockLocationShape);
exports.updateStockLocationSchema = exports.createStockLocationSchema.partial();
//# sourceMappingURL=stock-location.schema.js.map